<template>
  <div>
    <apexchart ref="chart" type="donut" width="100%" :options="options" :series="pieData" />

    <v-select
      multiple
      taggable
      v-model="selectedLabels"
      @input="handleSelectedLabel"
      label="name"
      :options="labels"
      :reduce="label => label.id"
      placeholder="kies een of meerdere labels"
      class="show-opposite"
    ></v-select>
    <div class="text-left show-opposite">
      <div>
        <zi-checkbox v-model="includeOpposite">Restant van de niet gekozen issues laten zien.</zi-checkbox>
      </div>
      <div v-if="includeOpposite">
        <zi-checkbox v-model="includeNonLabelled">Gebruik niet issues die geen label hebben.</zi-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import find from 'lodash-es/find'
import map from 'lodash-es/map'

export default {
  name: 'LabelPie',
  computed: {
    dateFrom() {
      return this.$store.getters.dateFrom
    },
    dateTo() {
      return this.$store.getters.dateTo
    },
    labels() {
      return this.$store.getters.getLabels
    },
    issues() {
      return this.$store.getters.issuesAll.filter(issue => {
        if (!this.includeNonLabelled && issue.labels.length === 0) {
          return false
        }

        let iss = dayjs(issue.created_at)

        if (!this.dateFrom || !this.dateTo) {
          return true
        }

        return (
          (iss.isAfter(this.dateFrom) || iss.isSame(this.dateFrom)) &&
          (iss.isBefore(this.dateTo) || iss.isSame(this.dateTo))
        )
      })
    },
    pieData() {
      // when no labels selected
      if (this.selectedLabels.length === 0) {
        const open = this.issues.filter(i => i.closed_at === null).length,
          closed = this.issues.filter(i => i.closed_at !== null).length

        return [open, closed]
      }

      let result = this.labels
        .filter(label => this.selectedLabels.indexOf(label.id) !== -1)
        .map(label => {
          return this.issues.filter(
            issue => issue.labels.indexOf(label.name) !== -1
          ).length
        })

      if (this.includeOpposite) {
        let totaly = result.length > 0 ? result.reduce((x, y) => (x += y)) : 0

        result.push(this.grantTotal - totaly)
      }

      return result
    },
    grantTotal() {
      return this.issues.length
    },
  },
  mounted() {
    if (this.selectedLabels.length === 0) {
      this.options.labels = ['Open', 'Closed']
      this.$refs.chart.updateOptions({
        labels: this.options.labels,
      })
    }

    this.$watch('selectedLabels', this.handleWatcher, { immediate: true })
    this.$watch('includeOpposite', this.handleWatcher, { immediate: true })
    this.$watch('$route.query', this.handleWatcher)
  },
  data: () => ({
    includeOpposite: true,
    includeNonLabelled: true,
    selectedLabels: [],
    options: {
      labels: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '28px',
              },
              value: {
                show: true,
              },
              total: {
                show: true,
                fontSize: '28px',
                color: 'inherit',
              },
            },
          },
        },
      },
    },
  }),
  methods: {
    handleSelectedLabel(selected) {
      this.options.labels = map(selected, 'name')
    },

    handleWatcher() {
      if (this.selectedLabels.length === 0) {
        this.options.labels = ['Open', 'Closed']
      } else {
        this.options.labels = this.labels
          .filter(label => this.selectedLabels.indexOf(label.id) !== -1)
          .map(label => label.name)

        if (this.includeOpposite) {
          this.options.labels.push('Restant(en)')
        }
      }

      this.$refs.chart.updateOptions({
        labels: this.options.labels,
      })
    },
  },
}
</script>

<style>
.text-left {
  text-align: left;
}
.show-opposite {
  padding-top: 20px;
}
</style>